export const FILE_UPLOAD_STARTED = 'FILE_UPLOAD_STARTED';
export const FILE_UPLOAD_PROGRESS = 'FILE_UPLOAD_PROGRESS';
export const FILE_UPLOAD_SUCCEEDED = 'FILE_UPLOAD_SUCCEEDED';
export const FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FAILED';
export const REMOVE_FILE_UPLOAD = 'REMOVE_FILE_UPLOAD';